import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';


type SecurityGroupingTab = 'groupings' | 'assignAdministrators' | 'assignEmployees' | 'assigned';

const VALID_TABS: SecurityGroupingTab[] = ['groupings', 'assignAdministrators', 'assignEmployees', 'assigned'];

export interface UseSecurityGroupingPageResult {
  activeTab: SecurityGroupingTab;
  handleBackClick: () => void;
  handleTabChange: (id: string) => void;
}

export function useSecurityGroupingPage(): UseSecurityGroupingPageResult {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<SecurityGroupingTab>('groupings');

  const handleBackClick = useCallback(() => {
    void navigate(-1);
  }, [navigate]);

  const handleTabChange = useCallback((id: string) => {
    if ((VALID_TABS as string[]).includes(id)) {
      setActiveTab(id as SecurityGroupingTab);
    }
  }, []);

  return {
    activeTab,
    handleBackClick,
    handleTabChange,
  };
}
